import base from './base';

export default {
  ...base,
  name: 'dev',
  herbieApiHost: 'https://api.cobli.co/herbie-1.1',
  apiHost: 'https://api.cobli.co',
  apiV2: 'https://api.cobli.co/v2',
  experience: 'https://api.cobli.co/public/',
  sentryDsn: '',
  segmentAnalyticsKey: 'HT9TQZ1JlTTcioOFuqui3EPgDeYj0v9Y', // TODO create dev env
  googleMapsKey: 'AIzaSyDhGp8Wx17GWE4XHW8n1IGNi2RbUVYmGFY',
  cobliInviteUrl: 'https://cadastro.cobli.co/invites',
  graphqlHost: 'https://api.cobli.co/graphql',
  oneSignalAppId: '',
  ddRUMapplicationId: '',
  ddRUMclientToken: '',
  cerberusHost: 'https://api-dev.cobli.co/api-keys',
  launchDarklyId: '5b69f3c2ffcc3e1ec6336136',
  clarityId: '',
  geofenceApiHost: 'https://api.cobli.co/v3/geofences',
  alertsApiHost: 'https://api.cobli.co/v1/triggers',
};
